export class CatalogConfig {
  manageProductImages: boolean = true;
  showProductReference: boolean = true;
  manageVariants: boolean = true;
  manageReferenceUnit: boolean = false;
  manageCategories: boolean = true;
  manageProductTags: boolean = true;
  defaultTaxGroupId: number | null = null;
  trackingSerialEnabled: boolean = false;
  trackingBatchEnabled: boolean = false;
  requireBrand: boolean = false;
}